<template>
  <div class="app">
    <router-view></router-view>
    <loading :active.sync="$store.state.isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
  </div>
</template>

<script>
import api from './service/service.js'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Swal from 'sweetalert2'

export default {
  name: 'app',
  components: {
    Loading
  },
  data () {
    return {}
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.$store.state.screenWidth = window.innerWidth
      this.$store.state.screenHeight = window.innerHeight
    },
    Config () {
      api.getConfig(
        result => {
          if (result.result === true) {
            sessionStorage.Config = JSON.stringify(result.data[0])
            this.$store.state.config = JSON.parse(sessionStorage.Config)
          } else {
            Swal.fire(
              'Get Config Fail!',
              result.data,
              'error'
            )
          }
        },
        error => {
          Swal.fire(
            'Get Config Fail!',
            JSON.stringify(error),
            'error'
          )
        }
      )
    }
  },
  mounted () {
    this.Config()
    if (!api.LoggedIn()) {
      this.$router.push({name: 'Login'})
    } else {
      this.$store.state.user = JSON.parse(sessionStorage.Data)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue